import { RefObject, useEffect } from 'react';

interface UseGlobalSearchQueryControlsParams {
  isOpen: boolean;
  query: string;
  inputRef: RefObject<HTMLInputElement>;
  setQuery: (query: string) => void;
  setActiveTabId: (tabId: string) => void;
  onQueryCleared: () => void;
}

const useGlobalSearchQueryControls = ({
  isOpen,
  query,
  inputRef,
  setQuery,
  setActiveTabId,
  onQueryCleared,
}: UseGlobalSearchQueryControlsParams) => {
  useEffect(() => {
    if (!isOpen) {
      setQuery('');
      setActiveTabId('');
      return undefined;
    }

    const focusHandle = requestAnimationFrame(() => inputRef.current?.focus());
    return () => cancelAnimationFrame(focusHandle);
  }, [isOpen, setQuery, setActiveTabId, inputRef]);

  useEffect(() => {
    if (!isOpen || query !== '') {
      return;
    }
    setActiveTabId('');
    onQueryCleared();
  }, [isOpen, query, setActiveTabId, onQueryCleared]);

  const handleSelectRecent = (recent: string) => {
    setQuery(recent);
    requestAnimationFrame(() => inputRef.current?.focus());
  };

  const handleClearQuery = () => {
    setQuery('');
    inputRef.current?.focus();
  };

  return {
    handleSelectRecent,
    handleClearQuery,
  };
};

export default useGlobalSearchQueryControls;
